import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../hooks/hooks";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import useWindowDimensions from '../../../hooks/useWindowsDimensions';
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { termsLibraries } from "../../../redux/terms-libraries/action";
import {  selectTermsLibrariesListItems, selectTermsLibrariesQueryItems } from "../../../redux/terms-libraries/selector";
import { sections } from "../../../redux/sections/action";
import { HTMLContent } from "../../../common/components/html-content";
import { selectSectionsQueryItems } from "../../../redux/sections/selector";
import PageLoader from "../../../components/PageLoader";

export const PrivacyPolicy = () => {
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const { height, width } = useWindowDimensions();
	const listItems: any = useSelector(selectTermsLibrariesListItems)
	const queryItem: any = useSelector(selectTermsLibrariesQueryItems);
	const sectionQueryItems: any = useSelector(selectSectionsQueryItems);
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const [color, setColor] = useState('universal')
	const [primary, setPrimary] = useState('#FFB934FF')
	const [secondary, setSecondary] = useState('#FFB934FF')
	const [termsData, setTermsData] = useState<any>({})
	const theme: any = 'lightmode'


	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			setPrimary('#f5e93cac')
			setSecondary('#ffffff')
		}
		else if (theme == 'lightmode') {
			setPrimary('#ffffffa2')
			setSecondary('#000000a2')
		}
		else if (theme == 'universal') {
			setPrimary('#233C64')
			setSecondary('#ffffff')
		}
		else if (theme == 'luxury') {
			setPrimary('#bd238c')
			setSecondary('#ffffff')
		}
		else if (theme == 'harmony') {
			setPrimary('#000000a2')
			setSecondary('#000000a2')
		}
		else if (theme == 'warmth') {
			setPrimary('#000000a2')
		}
	}, [theme]);



	useEffect(() => {
		getPrivacyPolicyTerms();
	}, [])
	useEffect(() => {
		if(listItems?.isSuccess && listItems?.result?.items.length > 0){
			
			dispatch(termsLibraries.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/query`,entity:'termsLibraries',jsonData:
			{
				"Records": [
				  {
					"Id": listItems?.result?.items[0].Id
				  }
				]
			  }
			}))
			dispatch(termsLibraries.resetAction({actionType:'list'}))
		}		
	}, [listItems]);

	useEffect(() => {
		if( queryItem?.isSuccess && queryItem?.result?.items?.SectionIds.length > 0 ){
			dispatch(sections.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/terms-library/sections/query`,entity:'sections',jsonData:
			{
				"Records": [
				  {
					"Id": queryItem?.result?.items?.SectionIds[0]
				  }
				]
			  }
			}))
			dispatch(termsLibraries.resetAction({actionType:'query'}))
		}
	}, [queryItem]);

	useEffect(() => {
		if(sectionQueryItems?.isSuccess){
			setTermsData(sectionQueryItems?.result?.items)
			setIsLoading(false)
			dispatch(sections.resetAction({actionType:'query'}))
		}
		
	}, [sectionQueryItems]);
	const getPrivacyPolicyTerms = async () => {
		
		dispatch(termsLibraries.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/e-applications/contract/terms-libraries/list`,entity:'termsLibraries',jsonData:
			{    
				"PageNumber": 1,
				"PageSize": 1,
				"SortField": "Id",
				"SortOrder": "Desc",
				"isOrCondition": true,
				"isFilterConditionOr": true,
				"isSearchConditionOr": true,
				"Filters": [
				  {
					"FieldName": "TermsNameLibraryId",
					"FilterOperatorId": 1,
					"FieldValue": 50,
					"FieldType": "number"
				  }
				]
			}
		}));
	}
	return (
		<>
		   {isLoading ? <PageLoader />
 : <>
			{width && width < 720 ? <div className={`max-h-screen py-5`}>
				<div className="z-20 h-full py-10 pb-24 overflow-y-auto mt-12">
				<div className="flex w-full flex-col items-start justify-between uppercase text-xl p-10" >
									{termsData?.Name}
								</div>
								<div className="p-4 w-full  justity-center items-center">
									{termsData && <HTMLContent htmlContent={`${termsData?.Description}`} />}
								</div>
				</div>
				
			</div > :
				<div className="overflow-y-auto flex flex-col justify-between items-stretch bg-white  px-20 py-10">

					<div className="flex flex-row ">
						<div className="w-full  justity-center items-center">
							<div className="w-full bg-white ">
								<div className="flex w-full flex-col items-start justify-between uppercase text-xl p-10" >
									{termsData?.Name}
								</div>
								<div className="">
									{termsData && <HTMLContent htmlContent={`${termsData?.Description}`} />}
								</div>
							</div>
						</div>
					</div>

				</div>}</>}
		</>
	)
}

